import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({
	providedIn: 'root'
})
export class PlatformService {
	public isBrowser = false
	public isServer = false
	constructor(@Inject(PLATFORM_ID) private platform: Object) {
		if (isPlatformBrowser(platform)) {
			this.isBrowser = true
		} else if (isPlatformServer(this.platform)) {
			this.isServer = true
		}
	}
}
